import React, { useState } from "react";
import { BsStarFill, BsStarHalf, BsStar } from "react-icons/bs";
import Spinner from "../Spinner";
import { TooltipContainer, RatingContainer } from "./styles";

const starsStatus = ["Péssimo", "Ruim", "Neutra", "Bom", "Ótima"];

type RatingProps = {
    name: string;
    label?: string;
    rating?: number;
    numberStars?: number;
    value?: string | number;
    direction?: "row" | "column";
    spaceContent?: boolean;
    loading?: boolean;
    error?: string;
    showTippy?: boolean;
    onChange: (name: string, value: string) => void;
    onBlur?: (name: string, value: string) => void;
};

const Rating = ({
    name,
    rating,
    numberStars = 5,
    value,
    direction = "row",
    spaceContent = false,
    loading = false,
    showTippy = true,
    onChange,
    onBlur,
}: RatingProps) => {
    const stars = new Array(numberStars).fill(null).map((num, index) => (num = index + 1));
    const [showTooltip, setShowToolTip] = useState(false);
    const [currentStar, setCurrentStar] = useState<number>(null);

    const handleChange = (changeValue: number) => {
        const submitValue = value === changeValue.toString() ? "" : changeValue.toString();
        onChange(name, submitValue);
        setShowToolTip(false);

        if (!onBlur) {
            return;
        }

        onBlur(name, submitValue);
    };

    return (
        <RatingContainer direction={direction} spaceContent={spaceContent}>
            <div className="rating">
                <p>{name}</p>
                <div>
                    {loading ? (
                        <Spinner />
                    ) : (
                        stars.map((index) => (
                            <TooltipContainer showTooltip={showTooltip && currentStar === index && showTippy}>
                                <button
                                    type="button"
                                    onClick={() => handleChange(index)}
                                    onMouseEnter={() => {
                                        setCurrentStar(index);
                                        setShowToolTip(true);
                                    }}
                                    onMouseLeave={() => {
                                        setCurrentStar(null);
                                        setShowToolTip(false);
                                    }}
                                >
                                    <span>
                                        {Number(value) >= index ? (
                                            <BsStarFill />
                                        ) : Number(value) >= index - 0.5 ? (
                                            <BsStarHalf />
                                        ) : (
                                            <BsStar />
                                        )}
                                    </span>
                                </button>
                                <div className="tooltip-content">
                                    <div className="msg">
                                        <p>{starsStatus[index - 1]}</p>
                                    </div>
                                </div>
                            </TooltipContainer>
                        ))
                    )}
                </div>
            </div>
        </RatingContainer>
    );
};

export default Rating;
